import { megerArrayList } from "core/utils/helper";
import {
  FETCH_LIST_TRENDING_COMMUNITY_REQUEST,
  FETCH_LIST_TRENDING_COMMUNITY_SUCCESS,
  FETCH_LIST_TRENDING_COMMUNITY_ERROR,
  FETCH_LIST_FOLLOW_COMMUNITY_REQUEST,
  FETCH_LIST_FOLLOW_COMMUNITY_SUCCESS,
  FETCH_LIST_FOLLOW_COMMUNITY_ERROR,
  FETCH_LIST_VIDEO_COMMUNITY_REQUEST,
  FETCH_LIST_VIDEO_COMMUNITY_SUCCESS,
  FETCH_LIST_VIDEO_COMMUNITY_ERROR,

  CREATE_COMMUNITY_REQUEST,
  CREATE_COMMUNITY_SUCCESS,
  CREATE_COMMUNITY_ERROR,
  RESET_CREATE_COMMUNITY,

  FETCH_LIST_COMMENT_REQUEST,
  FETCH_LIST_COMMENT_SUCCESS,
  FETCH_LIST_COMMENT_ERROR,
  RELOAD_LIST_COMMENT_REQUEST,
  RELOAD_LIST_COMMENT_SUCCESS,

  CREATE_COMMENT_REQUEST,
  CREATE_COMMENT_SUCCESS,
  CREATE_COMMENT_ERROR,

  DELETE_COMMENT_REQUEST,
  REPORT_COMMENT_REQUEST,

  FETCH_STATISTIC_CHANNEL_REQUEST,
  FETCH_STATISTIC_CHANNEL_SUCCESS,
  FETCH_STATISTIC_CHANNEL_ERROR,
  FETCH_LIST_USER_POSTS_REQUEST,
  FETCH_LIST_USER_POSTS_SUCCESS,
  FETCH_LIST_USER_POSTS_ERROR,
  FETCH_FOLLOW_STATUS_REQUEST,
  FETCH_FOLLOW_STATUS_SUCCESS,
  FETCH_FOLLOW_STATUS_ERROR,
  UPDATE_FOLLOW_USER_REQUEST,
  UPDATE_FOLLOW_USER_SUCCESS,
  UPDATE_FOLLOW_USER_ERROR,
  DELETE_POST_REQUEST,
  DELETE_POST_SUCCESS,
  DELETE_POST_ERROR,
  UPDATE_LIST_POST,
  REACTION_POST_REQUEST,
  REACTION_POST_SUCCESS,
  REACTION_POST_ERROR,
  FETCH_DETAIL_POST_REQUEST,
  FETCH_DETAIL_POST_SUCCESS,
  FETCH_DETAIL_POST_ERROR,
  RESET_LIST_USER_POSTS,
  REACTION_COMMENT_REQUEST,
  REACTION_COMMENT_SUCCESS,
  REACTION_COMMENT_ERROR,
} from "./actions";

export interface DataState {
  trending: {
    data: any;
    loading: boolean;
    error: Error | null;
    params: {
      page: number;
      page_size: number;
      cache_key?: string;
      limit?: number;
      last_id?: any;
    };
    lastPage: number;
  };
  follow: {
    data: any;
    loading: boolean;
    error: Error | null;
    params: {
      page: number;
      page_size: number;
    };
    lastPage: number;
  };
  video: {
    data: any;
    loading: boolean;
    error: Error | null;
    params: {
      page: number;
      page_size: number;
    };
    lastPage: number;
  };
  create: {
    data: any;
    loading: boolean;
    error: Error | null;
  };
  personal_channel: {
    data: any;
    loading: boolean;
    error: Error | null;
    params: {
      page: number;
      page_size: number;
      order_by: string;
      order_dir: string;
    };
    lastPage: number;
    statistics: any;
    state_follow: boolean;
    loadingStatisticFollow: boolean;
    loadingDeletePost: boolean;
  };
  comments: {
    data: any;
    loading: boolean;
    loadingForm: boolean;
    error: Error | null;
    params: {
      post_id: any;
      limit: number,
      scroll_type: string,
      last_id: any,
      order_by: string;
      order_dir: string;
    };
    hasMore: boolean;
  };
  detail: {
    data: any;
    loading: boolean;
    error: Error | null;
  };
}

const initialState: DataState = {
  trending: {
    data: [],
    loading: false,
    error: null,
    params: {
      page: 1,
      page_size: 10,
    },
    lastPage: 1,
  },
  follow: {
    data: [],
    loading: false,
    error: null,
    params: {
      page: 1,
      page_size: 10,
    },
    lastPage: 1,
  },
  video: {
    data: [],
    loading: false,
    error: null,
    params: {
      page: 1,
      page_size: 10,
    },
    lastPage: 1,
  },
  create: {
    data: null,
    loading: false,
    error: null,
  },
  personal_channel: {
    data: [],
    statistics: {},
    state_follow: false,
    loading: false,
    loadingStatisticFollow: false,
    loadingDeletePost: false,
    error: null,
    params: {
      page: 1,
      page_size: 10,
      order_by: "created_at",
      order_dir: "desc",
    },
    lastPage: 1,
  },
  comments: {
    data: [],
    loading: false,
    loadingForm: false,
    error: null,
    params: {
      post_id: null,
      limit: 10,
      scroll_type: "down",
      last_id: null,
      order_by: "created_at",
      order_dir: "desc",
    },
    hasMore: true,
  },
  detail: {
    data: null,
    loading: false,
    error: null,
  }
};

const communityReducer = (
  state: DataState = initialState,
  action: any
): DataState => {
  switch (action.type) {
    case FETCH_LIST_TRENDING_COMMUNITY_REQUEST:
      return {
        ...state,
        trending: {
          ...state.trending,
          params: action.payload,
          loading: true,
        },
      };
    case FETCH_LIST_TRENDING_COMMUNITY_SUCCESS: {
      const { data: newData, cache_key } = action.payload;
      const { params }: any = state.trending;
      const listData =
        !params?.last_id
          ? action.payload.data
          : state.trending.data.concat(action.payload.data);
      return {
        ...state,
        trending: {
          ...state.trending,
          data: listData, 
          loading: false,
          error: null,
          lastPage: action.payload?.last_page,
          params: {
            ...state.trending.params,
            last_id: newData[newData.length - 1]?.index_key || null,
            cache_key,
          },
        },
      };
    }
    case FETCH_LIST_TRENDING_COMMUNITY_ERROR:
      return {
        ...state,
        trending: {
          ...state.trending,
          loading: false,
          error: action.payload,
        },
      };
    //follow
    case FETCH_LIST_FOLLOW_COMMUNITY_REQUEST:
      return {
        ...state,
        follow: {
          ...state.follow,
          params: action.payload,
          loading: true,
        },
      };
    case FETCH_LIST_FOLLOW_COMMUNITY_SUCCESS: {
      const { params }: any = state.follow;
      const listData =
        params.page === 1
          ? action.payload.data
          : state.follow.data.concat(action.payload.data);

      return {
        ...state,
        follow: {
          ...state.follow,
          data: listData,
          loading: false,
          error: null,
          lastPage: action.payload?.last_page,
        },
      };
    }
    case FETCH_LIST_FOLLOW_COMMUNITY_ERROR:
      return {
        ...state,
        follow: {
          ...state.follow,
          loading: false,
          error: action.payload,
        },
      };

    case FETCH_LIST_VIDEO_COMMUNITY_REQUEST:
      return {
        ...state,
        video: {
          ...state.video,
          params: action.payload,
          loading: true,
        },
      };
    case FETCH_LIST_VIDEO_COMMUNITY_SUCCESS: {
      const { params }: any = state.video;
      const listData =
        params.page === 1
          ? action.payload.data
          : state.video.data.concat(action.payload.data);

      return {
        ...state,
        video: {
          ...state.video,
          data: listData,
          loading: false,
          error: null,
          lastPage: action.payload?.last_page,
        },
      };
    }
    case FETCH_LIST_VIDEO_COMMUNITY_ERROR:
      return {
        ...state,
        video: {
          ...state.video,
          loading: false,
          error: action.payload,
        },
      };

    // create community
    case CREATE_COMMUNITY_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case CREATE_COMMUNITY_SUCCESS:
      return {
        ...state,
        create: {
          ...state.create,
          data: action.payload,
          loading: false,
        },
      };
    case CREATE_COMMUNITY_ERROR:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_CREATE_COMMUNITY:
      return {
        ...state,
        create: {
          ...state.create,
          data: null,
          loading: false,
          error: null,
        },
      };
    case FETCH_STATISTIC_CHANNEL_REQUEST:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
        },
      };
    case FETCH_STATISTIC_CHANNEL_SUCCESS: {
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          statistics: action.payload,
        },
      };
    }
    case FETCH_STATISTIC_CHANNEL_ERROR:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          error: action.payload,
        },
      };
    case FETCH_LIST_USER_POSTS_REQUEST: {
      const { params }: any = state.personal_channel;
      let listDataMap = state.personal_channel.data as [];
      if (params.page === 1) {
        listDataMap = [];
      }
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: true,
          params: action.payload,
          data: listDataMap,
        },
      };
    }
    case FETCH_LIST_USER_POSTS_SUCCESS: {
      const { params }: any = state.personal_channel;
      let listDataMap = megerArrayList(state.personal_channel.data as [], action.payload.data)
      if (params.page === 1) {
        listDataMap = action.payload.data;
      }
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          data: listDataMap,
          loading: false,
          error: null,
          lastPage: action.payload?.last_page,
        },
      };
    }
    case FETCH_LIST_USER_POSTS_ERROR: {
      const { paramsList }: any = state.personal_channel;
      let listData = state.personal_channel.data as [];
      if (paramsList.page === 1) {
        listData = [];
      }
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: false,
          error: action.payload,
          data: listData,
        },
      };
    }
    case RESET_LIST_USER_POSTS: {
        const { params }: any = state.personal_channel;
        params.page = 1
        return {
          ...state,
          personal_channel: {
            ...state.personal_channel,
            data: [],
            loading: false,
            error: null,
            params: params,
          },
        };
      }
    case FETCH_FOLLOW_STATUS_REQUEST:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loadingStatisticFollow: true,
        },
      };
    case FETCH_FOLLOW_STATUS_SUCCESS: {
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          state_follow: action.payload,
          loadingStatisticFollow: false,
        },
      };
    }
    case FETCH_FOLLOW_STATUS_ERROR:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          error: action.payload,
          loadingStatisticFollow: false,
        },
      };
    case UPDATE_FOLLOW_USER_REQUEST:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: true,
        },
      };
    case UPDATE_FOLLOW_USER_SUCCESS: {
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: false,
          state_follow: !state.personal_channel.state_follow,
        },
      };
    }
    case UPDATE_FOLLOW_USER_ERROR:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: false,
          error: action.payload,
        },
      };
    case DELETE_POST_REQUEST:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loadingDeletePost: true,
        },
      };
    case DELETE_POST_SUCCESS: {
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loadingDeletePost: false,
        },
      };
    }
    case DELETE_POST_ERROR:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loadingDeletePost: false,
          error: action.payload,
        },
      };
    case UPDATE_LIST_POST: 
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          data: action.payload?.listUpdate || state.personal_channel.data,
          loading: false,
          error: action.payload,
        },
      };
    case REACTION_POST_REQUEST: {
      console.log('reactionPostRequest', action.payload);
      //update list post by tab
      const { tab }: any = action.payload;
      const listPost = (state as any)[tab].data.map((item: any) => {
        console.log('item', item);
        console.log('action.payload', action.payload);
        
        if (+item.id === +action.payload.id) {
          console.log('item.like_count', item.id, action.payload.id);
          return { 
            ...item, 
            user_reaction: action.payload.stateActive ? 1 : 0,
            total_likes: action.payload.stateActive ? item.total_likes + 1 : item.total_likes - 1
          };
        }
        return item;
      });
      console.log('listPost', listPost);
      return {
        ...state,
        [tab]: {
          ...(state as any)[tab],
          data: listPost,
        },
        personal_channel: {
          ...state.personal_channel,
          loading: true,
        },
      };
    }
    case REACTION_POST_SUCCESS: {
      console.log('reactionPostSuccess', action.payload);
      
      return {
          ...state,
          personal_channel: {
            ...state.personal_channel,
            loading: false,
          },
        };
      }
    case REACTION_POST_ERROR:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: false,
          error: action.payload,
        },
      };
    case FETCH_DETAIL_POST_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case FETCH_DETAIL_POST_SUCCESS: {
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload,
          },
        };
      }
    case FETCH_DETAIL_POST_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          error: action.payload,
        },
      };
    case REACTION_COMMENT_REQUEST:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: true,
        },
        comments: {
          ...state.comments,
          data: state.comments.data.map((item: any) => {
            if (item.id === action.payload.comment_id) {
              return {
                ...item,
                user_reaction: +action.payload.stateActive,
              };
            }
            return item;
          }),
        },
      };
    case REACTION_COMMENT_SUCCESS: {
      return {
          ...state,
          personal_channel: {
            ...state.personal_channel,
            loading: false,
          },
        };
      }
    case REACTION_COMMENT_ERROR:
      return {
        ...state,
        personal_channel: {
          ...state.personal_channel,
          loading: false,
          error: action.payload,
        },
      };

    // comment
    // comment list
    case FETCH_LIST_COMMENT_REQUEST: {
      return {
        ...state,
        comments: {
          ...state.comments,
          loading: true,
          params: action.payload,
          data: !action.payload?.last_id || action.payload.post_id !== state.comments.params.post_id
            ? []
            : state.comments.data,
        },
      };
    }
    case FETCH_LIST_COMMENT_SUCCESS: {
      const { params }: any = state.comments;
      const listData = state.comments.data.concat(action.payload);
      return {
        ...state,
        comments: {
          ...state.comments,
          data: listData,
          loading: false,
          error: null,
          hasMore: action.payload.length === params.limit,
        },
      };
    }
    case FETCH_LIST_COMMENT_ERROR:
      return {
        ...state,
        comments: {
          ...state.comments,
          loading: false,
          error: action.payload,
        },
      };
    case RELOAD_LIST_COMMENT_REQUEST: {
      return state;
    }
    case RELOAD_LIST_COMMENT_SUCCESS: {
      return {
        ...state,
        comments: {
          ...state.comments,
          data: action.payload,
        },
      };
    }
    // create comment
    case CREATE_COMMENT_REQUEST:
      console.log('CREATE_COMMENT_REQUEST', action.payload);
      return {
        ...state,
        comments: {
          ...state.comments,
          loadingForm: true,
        },
      };
    case CREATE_COMMENT_SUCCESS: {
      // prepend new comment to the top of the list
      console.log('CREATE_COMMENT_SUCCESS', action.payload);
      //update list comment by tab
      const { tab }: any = action.payload;
      const listComment = (state as any)[tab].data.map((item: any) => {
        if (+item.id === +action.payload.post_id) {
          return { ...item, total_comments: item.total_comments + 1 };
        }
        return item;
      });
      return {
        ...state,
        [tab]: {
          ...(state as any)[tab],
          data: listComment,
        },
        comments: {
          ...state.comments,
          data: [action.payload, ...state.comments.data],
          loadingForm: false,
          error: null,
        },
        // count comment + 1 in detail if detail exist
        detail: {
          ...state.detail,
          data: state.detail.data
            ? {
                ...state.detail.data,
                total_comments: state.detail.data.total_comments + 1,
              }
            : null,
        },
      };
    }
    case CREATE_COMMENT_ERROR:
      return {
        ...state,
        comments: {
          ...state.comments,
          loadingForm: false,
          error: action.payload,
        },
      };
    // delete comment
    case DELETE_COMMENT_REQUEST:
      // remove item from the list by comment_id
      return {
        ...state,
        comments: {
          ...state.comments,
          data: state.comments.data.filter(
            (item: any) => +item.id !== +action.payload.comment_id
          ),
        },
      };
    // delete comment
    case REPORT_COMMENT_REQUEST:
      // remove item from the list by comment_id
      return {
        ...state,
        comments: {
          ...state.comments,
          data: state.comments.data.filter(
            (item: any) => +item.id !== +action.payload.comment_id
          ),
        },
      };
    // end comment
    default:
      return state;
  }
};

export default communityReducer;
